import restful from '../vuex'

const state = {
  ...restful.states('bill')
}

const getters = {
  ...restful.getters('bill')
}

const actions = {
  ...restful.actions('bills')
}

const mutations = {
  ...restful.mutations('bill')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
